import { FacebookIcon, InstagramIcon, Phone, Mail, ChevronsUp } from 'lucide-react';

export const Icons = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  phone: Phone,
  mail: Mail,
  chevronUp: ChevronsUp,
};
